import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CancelAppointmentSheetComponent } from '@sc/ui-components';
import { CancelAppointmentOutputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-cancel-appointment-dialog',
  styleUrls: ['./cancel-appointment-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CancelAppointmentSheetComponent],
  template: `
    <sc-cancel-appointment-sheet
      (quit)="onQuitDialog()"
      (acceptCancel)="onAcceptCancel($event)"
    ></sc-cancel-appointment-sheet>
  `,
})
export class CancelAppointmentDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<
      CancelAppointmentDialogComponent,
      CancelAppointmentOutputData
    >
  ) {}

  onQuitDialog() {
    this.dialogRef.close({
      type: 'cancel',
    });
  }

  onAcceptCancel(event: { comment: string; notifyClient: boolean }) {
    this.dialogRef.close({
      type: 'success',
      data: {
        comment: event.comment,
        notifyClient: event.notifyClient,
      },
    });
  }
}
